import React from "react";
import { Controller } from "react-hook-form";

import { Input, ErrorUI } from "@/components/Atoms";

import { InputGroupV3, InputWrapperV3 } from "../style";

const CityInput = ({
  name,
  control,
  showLabels,
  namePlaceholder,
  inputFontSize,
  inputLineHeight,
  handleBlur,
  isNotAbsolute,
}) => (
  <InputWrapperV3>
    <InputGroupV3 hasBottomBorder showLabels={showLabels}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur, onChange, ref },
          fieldState: { error },
          formState: { errors },
        }) => (
          <>
            <Input
              ref={ref}
              type="text"
              placeholder={namePlaceholder}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={(e) => {
                onBlur(e).then((e) => {
                  if (!errors?.[name] && value) handleBlur(e);
                });
              }}
              // icon="icon-user-face-2"
              iconDimension="16px"
              variant="v3"
              inputFontSize={inputFontSize}
              inputLineHeight={inputLineHeight}
            />
            {error && (
              <ErrorUI
                hasBottomBorder
                error={error?.message}
                isNotAbsolute={isNotAbsolute}
              />
            )}
          </>
        )}
      />
    </InputGroupV3>
  </InputWrapperV3>
);

export default CityInput;
